// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zcirxkvrqzsljzuoohey.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpjaXJ4a3ZycXpzbGp6dW9vaGV5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk0NzIxMDUsImV4cCI6MjA1NTA0ODEwNX0.vin3xtlpZNVFG_C4o-kWsDEacs22b60_2KjC5HUDeHQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);